/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import collectionsProvider from './collections-provider';

const collectionsSortProvider = {
  getList: async (resource, params) => {
    let hasMore = true;
    let page = 0;
    let collectionsData = [];
    while (hasMore) {
      const pageCollection = await collectionsProvider.getList('collections', {
        ...params,
        pagination: { ...params.pagination, page },
      });
      collectionsData = [...collectionsData, ...pageCollection.data];
      hasMore = pageCollection.hasMore;
      page += 1;
    }
    return { data: collectionsData, total: collectionsData.length };
  },

  getOne: async (resource, params) => {
    return collectionsProvider.getOne(resource, params);
  },

  getMany: (resource, params) => Promise,

  getManyReference: (resource, params) => Promise,

  create: async (resource, params) => {
    return collectionsProvider.create(resource, params);
  },

  update: async (resource, params) => {
    return collectionsProvider.update(resource, params);
  },

  updateMany: (resource, params) => Promise,

  delete: async (resource, params) => {
    return collectionsProvider.delete(resource, params);
  },

  deleteMany: (resource, params) => Promise,

  orderResource: async (resource, params) => {
    return collectionsProvider.orderResource(resource, params);
  },
};

export default collectionsSortProvider;
